const USER_ID_KEYNAME = 'custom:phorbs_user_id'
const BUSINESS_ID_KEYNAME = 'custom:business_id'
const USER_TYPE_KEYNAME = 'custom:user_type'

// ユーザー種別
const USER_TYPE_CUSTOMER = '1'
const USER_TYPE_PLANNER = '2'
const USER_TYPE_PARTNER = '3'
const USER_TYPE_RECEPTIONIST = '4'

// 施設ユーザーの場合の案件ID
const BUSINESS_ID_RECEPTIONIST = 0

const state = {
  user: null,
  attempt: null
}

const getters = {
  // ログインしているか？
  check: state => state.user !== null,
  name: state => state.user ? state.user.name : '',
  email: state => state.user ? state.user.email : '',
  userId: state => state.user ? state.user[USER_ID_KEYNAME] : '',
  // 案件ID
  businessId: state => state.user ? state.user[BUSINESS_ID_KEYNAME] : '',
  // 新郎新婦？
  isCustomer: state => (
    state.user ? state.user[USER_TYPE_KEYNAME] === USER_TYPE_CUSTOMER : false
  ),
  // プランナー or パートナー？
  isStaff: state => (
    state.user
      ? state.user[USER_TYPE_KEYNAME] === USER_TYPE_PLANNER ||
        state.user[USER_TYPE_KEYNAME] === USER_TYPE_PARTNER
      : false
  ),
  // パートナー？
  isPartner: state => (
      state.user ? state.user[USER_TYPE_KEYNAME] === USER_TYPE_PARTNER : false
  ),
  // プランナー？
  isPlanner: state => (
    state.user ? state.user[USER_TYPE_KEYNAME] === USER_TYPE_PLANNER : false
  ),
  // 施設？
  isFacility: state => (
    state.user
      ? state.user[USER_TYPE_KEYNAME] === USER_TYPE_RECEPTIONIST
      : false
  )
}

const mutations = {
  SET_USER(state, payload) {
    if (payload === null) {
      state.user = null
      return false
    }

    state.user = {}
    state.user.name = payload.name
    state.user.email = payload.email
    state.user.sub = payload.sub

    // カスタム属性
    Object.keys(payload).forEach(key => {
      if (key.indexOf('custom:') === 0) {
        state.user[key] = payload[key]
      }
    })

    // 施設ユーザーの場合は案件IDはゼロ
    if (payload[USER_TYPE_KEYNAME] === USER_TYPE_RECEPTIONIST) {
      state.user[BUSINESS_ID_KEYNAME] = BUSINESS_ID_RECEPTIONIST
    }
  },
  SET_BUSINESS_ID(state, payload) {
    state.user = Object.assign({}, state.user, {
      [BUSINESS_ID_KEYNAME]: payload
    })
  },
  SET_ATTEMPT(state, payload) {
    state.attempt = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
